const _baseServerUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'http://www.qoct.cn' // 公网
// const _baseServerUrl = process.env.NODE_ENV === 'development' ? 'https://localhost:5001' : 'http://10.135.246.156:8058' // 内网
// const _baseServerUrl = process.env.NODE_ENV === 'development' ? 'https://localhost:5001' : 'http://localhost:5000' // 内网测试

const _baseServerUrlApi = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : 'http://www.qoct.cn/api' // 公网
// const _baseServerUrlApi = process.env.NODE_ENV === 'development' ? 'https://localhost:5001/api' : 'http://10.135.246.156:8058/api' // 内网
// const _baseServerUrlApi = process.env.NODE_ENV === 'development' ? 'https://localhost:5001/api' : 'http://localhost:5000/api' // 内网测试

const _baseOnlineUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8081' : 'http://www.qoct.cn'
export default {
  baseServerUrl: _baseServerUrl,
  baseServerUrlApi: _baseServerUrlApi,
  baseOnlineUrl: _baseOnlineUrl,
  // baseUnderlineUrl: _baseUnderlineUrl
}
